import request from '@/utils/request'

export function index(bibleCode) {
  return request({
    url: '/bible' + (bibleCode ? '/' + bibleCode : ''),
    method: 'get',
  })
}

export function search(year) {
  return request({
    url: '/ticket',
    params: {
      year: year,
    },
    method: 'get'
  })
}

